module.exports = __webpack_public_path__ + "static/Graphik-Semibold-1d9c3bcff9c867d2b43397574f467782.ttf";